import {Button, ModalPopup} from '@kit';

import React, {useEffect, useState} from 'react';

import {useRoute, navigate, SiteRoutes} from '../lib/routes';
import {FeatureView, FeatureParentObject, PartialFeature} from './feature-view';

type Props = {
	route: keyof SiteRoutes;
	params?: SiteRoutes[keyof SiteRoutes];
	features: PartialFeature[];
	featureParent: FeatureParentObject;
};

export function useFeatureModal({route, params, features, featureParent}: Props) {
	const router = useRoute();
	const query = (router?.query || {}) as {featureId: string};
	const {featureId} = query;

	const [showingFeatureId, setShowingFeatureId] = useState<string | null>(null);
	useEffect(() => {
		setShowingFeatureId(featureId);
	}, [featureId]);

	const handleCloseFeature = () => {
		navigate(route, params);
		setShowingFeatureId(null);
	};

	return showingFeatureId ? (
		<ModalPopup open={true} onClose={handleCloseFeature} historyEntry={false}>
			<FeatureView
				feature={features.find((feature) => feature.id === showingFeatureId)!}
				parentObject={featureParent}
				alwaysH1
			/>
			<ul className={'modal-popup-buttons'}>
				<li>
					<Button onClick={handleCloseFeature}>Закрыть</Button>
				</li>
			</ul>
		</ModalPopup>
	) : null;
}
